import requestv2 from "~/utils/http-v2";

const promotionApi = {
    get : async (params) => {
        const url = 'v2/promotion';
        return await requestv2.get(url, {params});
    },
    detail : async (params) => {
        const url = `v2/promotion/detail/${params.id}`;
        return await requestv2.get(url, {params});
    },
    add : async (params) => {
        const url = 'v2/promotion';
        return await requestv2.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    update : async (id, params) => {
        const url = `v2/promotion/update/${id}`;
        return await requestv2.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    status : async (params) => {
        const url = `v2/promotion/status/${params.id}`;
        return await requestv2.post(url, params);
    },
};

export default promotionApi;